import { Camera, Image, Loader2 } from 'lucide-react';

export function PhotoIcon() {
  return <Image className="h-6 w-6 shrink-0 text-gray-500" />;
}

export function CameraIcon() {
  return <Camera className="h-6 w-6 shrink-0 text-gray-500" />;
}

export function Spinner() {
  return <Loader2 className="h-5 w-5 shrink-0 animate-spin text-brand-700" />;
}
